import { render, staticRenderFns } from "./FFWax.vue?vue&type=template&id=046092d4"
import script from "./FFWax.vue?vue&type=script&lang=js"
export * from "./FFWax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports